import type { BaseImageData } from "@/api/useInventory.types"

type StringField<T> = {
  [K in keyof T]: T[K] extends string | string[] ? K : never
}[keyof T]

export const getBaseImageProperty = <K extends StringField<BaseImageData>>(
  baseImagesData: BaseImageData[] | undefined,
  field: K
): string[] =>
  (baseImagesData || []).flatMap((baseImage) => baseImage[field] || [])
